import React, { useEffect } from 'react';
import Preloader from '../../helper/Preloader';
import HeaderOne from '../../components/layout/HeaderOne';
import HeaderHome from '../../components/layout/HeaderHome';
import ProductDetail from '../../components/product/ProductDetail';
import NewArrivalTwo from '../../components/NewArrivalTwo';
import FooterOne from '../../components/layout/FooterOne';
import BottomFooter from '../../components/layout/BottomFooter';
import BreadcrumbTwo from './../../components/BreadcrumbTwo';
import ScrollToTop from 'react-scroll-to-top';
import ColorInit from '../../helper/ColorInit';
import useProductBySlug from '../../hooks/useProductBySlug';
import { useParams } from 'react-router-dom';

const ProductDetailsPage = () => {
    const { slug } = useParams(); // Assuming you are using react-router-dom to get the slug from the URL

    const { fetchProductBySlug, data: product, status: productStatus, error: productError } = useProductBySlug();

    const { callViewProduct, data: result, status: resultStatus, error: resultError } = useProductBySlug();

    useEffect(() => {
        if (slug) {
            fetchProductBySlug(slug);
        }
    }, [slug]);

    useEffect(() => {
        if (product?.id) {
            callViewProduct(product.id);
        }
    }, [product]);

    // useEffect(()=>{
    //   console.log("data",product)
    // })

    return (
        <>
            {/* Preloader */}
            <Preloader />

            {/* ColorInit */}
            <ColorInit color={false} />

            {/* ScrollToTop */}
            <ScrollToTop smooth color="#990A02" />

            {/* HeaderOne */}
            {/* <HeaderOne /> */}
            <HeaderHome />

            {/* Breadcrumb */}
            <BreadcrumbTwo title={'Product Details'} breadcrumbTitle={'Product Detail'} />

            {/* ProductDetail */}
            <ProductDetail product={product} />

            {/* NewArrivalTwo */}
            <NewArrivalTwo productId={product?.id} />

            {/* FooterTwo */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default ProductDetailsPage;
